module.exports = __webpack_public_path__ + "static/img/3.Programmer-1.97f4eff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/3.Programmer-1.jpg
// module id = gdVZ
// module chunks = 1